import React from 'react';
import CreditsPage from '../components/partials/CreditsPage.jsx';

const CreditsContainer = (props) => {
    return (
        <div className="credits-page">
            <CreditsPage language={props.language} />
        </div>
    );
};

module.exports = CreditsContainer;



// WEBPACK FOOTER //
// ./js/containers/Credits.jsx